<template>
    <div class="product-list__col col-12 " v-if="layout === 'list' && !isMobile ">
        <category-list-item :item-data-list="item" :decimal-count="decimalCount" :item-list="true">

            <template name="after-prices"><slot name="after-prices"></slot></template>
            <template name="before-prices"><slot name="before-prices"></slot></template>

        </category-list-item>
    </div>
    <div v-else class="product-list__col col-12 col-6 col-md-4">
        <category-item :item-data-list="item" :decimal-count="decimalCount" :item-list="true">

            <template name="after-prices"><slot name="after-prices"></slot></template>
            <template name="before-prices"><slot name="before-prices"></slot></template>

        </category-item>
    </div>
</template>

<script>
    export default {
        props: {
            decimalCount:
                {
                    type: Number,
                    default: 0
                },
            itemData:
                {
                    type: Object
                },
            cookie: String
        },

        data(){
            return{
                layout: 'list',
                windowWidth: 0
            }
        },

        jsonDataFields: [
            "itemDataRef"
        ],

        mounted(){
            if(this.cookie === ""){
                this.layout = "list";
            }else{
                this.layout = this.cookie;
            }
            this.windowWidth = window.innerWidth;
            document.addEventListener('layout-changed', this.setItem, false);
            window.addEventListener('resize', this.setWidth);
        },

        computed:
            {
                isMobile() {
                    return this.windowWidth < 999;
                },

                item()
                {
                    return this.itemData || this.itemDataRef;
                },

            },

        methods: {

            setItem(event){
                this.layout = event.detail;
            },
            setWidth(){
                this.windowWidth = window.innerWidth;
            }
        }
    }
</script>
